import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Wrapper from 'common/navigation/wrapper';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import MainMenu from 'common/navigation/containers/main-menu-container';
import SubMenu from 'common/navigation/components/sub-menu';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import UserManagementContainer from './user-management/user-management-container';
import Absence from '../containers/absence/absence-container';
import CustomerCenterConfiguration
  from '../components/customer-center-configuration/customer-center-configuration';
import WorkingHours from '../containers/working-hours/working-hours-container';
import Skills from '../components/skills/skills';
import Announcements from '../components/announcements/announcements';
import usePermissionCheck from '../../utils/hooks/usePermissionCheck';
import StandaloneMode from '../components/standalone-settings/standalone-mode';
import Campaigns from '../components/campaigns/campaigns';
import WipCodes from '../components/wip-codes/wip-codes';
import settingsConfig from '../settings-config';

const SettingsRoutes = ({ intl }) => {
  const [checkPermission] = usePermissionCheck();
  let extraLinks = [];

  const renderMenu = (actionButtons) => {
    if (checkPermission(settingsConfig.permissions.usermanagement)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.USERS',
          uri: 'users',
          absolute: true,
        }];
    }

    if (checkPermission(settingsConfig.permissions.workinghours)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.WORKING_HOURS',
          uri: 'working-hours',
          absolute: true,
        },
      ];
    }

    if (checkPermission(settingsConfig.permissions.workinghours)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.ABSENCE',
          uri: 'absence',
          absolute: true,
        }];
    }

    if (checkPermission(settingsConfig.permissions.serviceCenterconfiguration)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.CC_CONFIG',
          uri: 'cc-config',
          absolute: true,
        }];
    }

    if (isToggleEnabled('skills') &&
      (
        checkPermission(settingsConfig.permissions.skillsmanager) ||
        checkPermission(settingsConfig.permissions.skillsassigner)
      )) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.SKILLS',
          uri: 'skills',
          absolute: true,
        },
      ];
    }

    if (isToggleEnabled('standaloneMode') &&
      checkPermission(settingsConfig.permissions.standalonemanager)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.STANDALONE_MODE',
          uri: 'standalone-mode',
          absolute: true,
        },
      ];
    }

    if (checkPermission(settingsConfig.permissions.announcementmanager)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.ANNOUNCEMENTS',
          uri: 'announcements',
          absolute: true,
        },
      ];
    }

    if (checkPermission(settingsConfig.permissions.campaignmanager)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.CAMPAIGNS',
          uri: 'campaigns',
          absolute: true,
        },
      ];
    }

    if (isToggleEnabled('wipCodes') &&
      checkPermission(settingsConfig.permissions.wipcodesmanagement)) {
      extraLinks = [
        ...extraLinks,
        {
          translationKey: 'nav.subNav.WIPCODES',
          uri: 'wip-codes',
          absolute: true,
        },
      ];
    }

    return (
      <MainMenu type='settings' actionButtons={actionButtons}>
        <SubMenu
          hasInfo={false}
          hasDashboard={false}
          extraLinks={extraLinks}
        />
      </MainMenu>
    );
  };

  return (
    <Wrapper title={intl.formatMessage({ id: 'common.titles.SETTINGS' })}>
      {renderMenu()}
      <Outlet />
      <Routes>
        <Route
          path={'users'}
          element={<UserManagementContainer />}
        />
        <Route
          path={'working-hours/:type?/:plant?/:region?/:fse?'}
          element={<WorkingHours />}
        />
        <Route
          path={'absence/:type?/*'}
          element={<Absence />}
        />
        <Route
          path={'cc-config/:type?/*'}
          element={<CustomerCenterConfiguration />}
        />
        <Route
          path={'skills/:type?/*'}
          element={<Skills />}
        />
        <Route
          path={'standalone-mode/*'}
          element={<StandaloneMode />}
        />
        <Route
          path={'announcements/*'}
          element={<Announcements />}
        />
        <Route
          path={'campaigns/*'}
          element={<Campaigns />}
        />
        <Route
          path={'wip-codes/*'}
          element={<WipCodes />}
        />
        {extraLinks?.length && <Route
          path={'*'}
          element={<Navigate to={extraLinks[0]?.uri} />}
        />}
      </Routes>
    </Wrapper>
  );
};

SettingsRoutes.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(SettingsRoutes);
